"use strict";
/* tslint:disable */
/* eslint-disable */
/**
 * API V1
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.ApiStoresUrlSlugPurchasesGet200ResponseToJSON = exports.ApiStoresUrlSlugPurchasesGet200ResponseFromJSONTyped = exports.ApiStoresUrlSlugPurchasesGet200ResponseFromJSON = exports.instanceOfApiStoresUrlSlugPurchasesGet200Response = void 0;
var runtime_1 = require("../runtime");
var Purchase_1 = require("./Purchase");
/**
 * Check if a given object implements the ApiStoresUrlSlugPurchasesGet200Response interface.
 */
function instanceOfApiStoresUrlSlugPurchasesGet200Response(value) {
    var isInstance = true;
    return isInstance;
}
exports.instanceOfApiStoresUrlSlugPurchasesGet200Response = instanceOfApiStoresUrlSlugPurchasesGet200Response;
function ApiStoresUrlSlugPurchasesGet200ResponseFromJSON(json) {
    return ApiStoresUrlSlugPurchasesGet200ResponseFromJSONTyped(json, false);
}
exports.ApiStoresUrlSlugPurchasesGet200ResponseFromJSON = ApiStoresUrlSlugPurchasesGet200ResponseFromJSON;
function ApiStoresUrlSlugPurchasesGet200ResponseFromJSONTyped(json, ignoreDiscriminator) {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        'purchases': !(0, runtime_1.exists)(json, 'purchases') ? undefined : (json['purchases'].map(Purchase_1.PurchaseFromJSON)),
    };
}
exports.ApiStoresUrlSlugPurchasesGet200ResponseFromJSONTyped = ApiStoresUrlSlugPurchasesGet200ResponseFromJSONTyped;
function ApiStoresUrlSlugPurchasesGet200ResponseToJSON(value) {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        'purchases': value.purchases === undefined ? undefined : (value.purchases.map(Purchase_1.PurchaseToJSON)),
    };
}
exports.ApiStoresUrlSlugPurchasesGet200ResponseToJSON = ApiStoresUrlSlugPurchasesGet200ResponseToJSON;
